module.exports = __webpack_public_path__ + "img/trio-page-5-elite.06105fab.jpg";